import $ from 'jquery';

$(window).on("scroll", function() {
  scrollAnime();
});
$(window).on("resize", function() {
  scrollAnime();
});
$(window).on("load", function() {
  $(".loading").fadeOut(600, function() {
    $(".container").css("opacity", "1");
    scrollAnime();
  });
  $(".nav_link[data-id='" + $("body").data("id") + "']").addClass("active");

});

// スクローラー
$('a.scroller[href^="#"]').on("click", function() {
  var target = $($(this).attr("href"));
  var position = target.offset().top;

  if( $(this).hasClass("follow_list") ){
    position = position - 80;
  }

  $('body,html').stop().animate({
    scrollTop: position
  }, 500);
  return false;
});

$(".openShare").on("click", function() {

  let URL = "https://www.asahi.com/ads/shopchannel25th";
  let TITLE = "ショップチャンネル25周年 変わるものと、変わらないもの｜朝日新聞デジタル";
  let TYPE = $(this).data("type");

  if ($(this).data("page")) {
    URL = URL + $(this).data("page");
    TITLE = $("title").first().text();
  }

  // SNS type
  switch (TYPE) {
    case "tw":
      URL = "https://twitter.com/intent/tweet?text=" + encodeURIComponent(TITLE) + "&url=" + URL;
      break;
    case "fb":
      URL = "https://www.facebook.com/sharer/sharer.php?u=" + URL;
      break;
    case "line":
      URL = "https://social-plugins.line.me/lineit/share?url=" + URL;
      break;
    default:
  }

  window.open(URL, TYPE, 'width=550, height=450, personalbar=0, toolbar=0, scrollbars=1, resizable=1');
});

// フェードイン アニメーション
function scrollAnime() {
  var windowHeight = $(window).innerHeight(),
    windowWidth = $(window).innerWidth(),
    topWindow = $(document).scrollTop(),
    docHeight = $(document).innerHeight(),
    fadeH = 300
    ;

  $('.fadein, .slidein').each(function() {
    var targetPosition = $(this).offset().top;

    fadeH = $(this).data("fadeheight") != undefined ? $(this).data("fadeheight") : fadeH;

    if (topWindow > targetPosition - windowHeight + (fadeH) || $(this).data("first") == 1) {
      $(this).addClass($(this).data("fadein"));
    }
  });
}
